import Amount from "@/models/Shared/Amount";

export default class CashbackTotals {
    period: string = '';
    transactionTotal: Amount = new Amount();
    cashbackTotal: Amount = new Amount();
}